const title = {
  type: 'Paragraph',
  name: '1',
  fontSize: '24px',
  lineHeight: '30px',
  fontSizeMedium: '32px',
  lineHeightMedium: '40px',
  fontWeight: '325'
}

const blockTitle = {
  type: 'Label',
  name: '3'
}

const blockText = {
  type: 'Paragraph',
  name: '3',
  fontFamily: 'ChronicleTextG1-Roman, Chronicle Display'
}

const loyaltyRewardsCarousel = {
  title,
  blockTitle,
  blockText
}

export default loyaltyRewardsCarousel
